<template>
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12">
          <h1 class="title">What's New?</h1>
          <p class="subtitle">
            Stay updated with the latest features and improvements.
          </p>
        </div>
        <div
          v-for="update in updates"
          :key="update.id"
          class="column is-4-desktop is-6-tablet is-12-mobile"
        >
          <div class="card">
            <div class="card-image">
              <figure class="image is-16by9">
                <img
                  :src="require(`@/assets/whats-new/${update.slides[0].image}`)"
                  :alt="update.title"
                />
              </figure>
            </div>
            <div class="card-content">
              <p class="title is-5 truncate">
                {{ update.title }}
              </p>
              <p class="subtitle is-6">{{ update.date }}</p>
              <div class="content truncate-3-lines">
                {{ update.slides[0].description }}
              </div>
              <button
                class="button is-size-6 is-info is-fullwidth"
                @click="onClick(update)"
              >
                More Info
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getUpdates } from '@/modules/whats-new/services/updates'
export default {
  name: 'WhatsNew',
  data() {
    return {
      updates: []
    }
  },
  mounted() {
    this.updates = getUpdates()
  },
  methods: {
    onClick(update) {
      this.$modal.open('whats-new/WhatsNew', {
        updates: [update]
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.card
  border: solid 1px $border-background
  box-shadow: none !important
.card-image img
  object-fit: cover
  border-bottom: solid 1px $border-background
</style>
